import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { DomainProvider } from '@/contexts/DomainContext';
import { initializeGA, trackPageView } from '@/services/analyticsService';
import { useDomain } from '@/contexts/DomainContext';
import { getDomainByHostname } from '@/config/domains';
import HomePage from '@/pages/HomePage';
import ArticlePage from '@/pages/ArticlePage';
import CategoryPage from '@/pages/CategoryPage';
import AboutPage from '@/pages/AboutPage';
import ContactPage from '@/pages/ContactPage';
import NotFoundPage from '@/pages/NotFoundPage';

// Component to handle page view tracking
const PageViewTracker: React.FC = () => {
  const location = useLocation();
  const { currentDomain } = useDomain();

  useEffect(() => {
    // Get domain from domains config
    const domain = getDomainByHostname(currentDomain);
    if (domain) {
      trackPageView(domain, location.pathname, document.title);
    }
  }, [location, currentDomain]);

  return null;
};

const App: React.FC = () => {
  useEffect(() => {
    // Initialize GA when app starts
    initializeGA();
  }, []);

  return (
    <Router>
      <DomainProvider>
        <PageViewTracker />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/:slug" element={<ArticlePage />} />
          <Route path="/categories/:slug" element={<CategoryPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </DomainProvider>
    </Router>
  );
};

export default App; 